import React from "react";

/**
 * Site-wide footer with legal links. Rendered on the Login page (most
 * important — Google's verification reviewers land here), inside the
 * dashboard, and on the legal pages themselves.
 *
 * The variant prop tunes the visual weight:
 *   - "marketing" : full row, used on the Login page
 *   - "app"       : compact, sits at the bottom of the authenticated dashboard
 *   - "minimal"   : single-line, used on the Legal pages where chrome is sparse
 */
export function SiteFooter({ variant = "marketing" }) {
  const year = new Date().getFullYear();

  if (variant === "minimal") {
    return (
      <footer className="border-t border-white/5 mt-12 py-6 text-center text-[11px] uppercase tracking-[0.18em] text-zinc-600" data-testid="site-footer">
        <FooterLinks />
        <div className="mt-2">© {year} VidROI · Remarkable Creators Ltd</div>
      </footer>
    );
  }

  if (variant === "app") {
    return (
      <footer className="border-t border-white/5 mt-12 px-6 sm:px-8 py-5 flex flex-wrap items-center justify-between gap-3" data-testid="site-footer">
        <div className="text-[11px] uppercase tracking-[0.18em] text-zinc-600">
          © {year} VidROI
        </div>
        <FooterLinks />
      </footer>
    );
  }

  // marketing — full
  return (
    <footer className="relative z-10 border-t border-white/5 px-6 py-8" data-testid="site-footer">
      <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-between gap-4">
        <div className="text-zinc-500 text-sm">
          © {year} <span className="text-white font-medium">Vid<span className="text-red-500">ROI</span></span> · Remarkable Creators Ltd · YouTube revenue attribution.
        </div>
        <FooterLinks />
      </div>
    </footer>
  );
}

function FooterLinks() {
  // Plain `<a>` tags (no react-router) — these are top-level routes the SPA
  // detects synchronously in App.js before authentication, so the full-page
  // load is fast and works for Google's unauthenticated verification crawler.
  return (
    <nav className="flex items-center gap-5 text-sm text-zinc-400" data-testid="site-footer-links">
      <a href="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy</a>
      <a href="/terms" className="hover:text-white transition-colors" data-testid="footer-terms-link">Terms</a>
      <a
        href="mailto:hello@vidroi.io"
        className="hover:text-white transition-colors"
        data-testid="footer-contact-link"
      >
        Contact
      </a>
    </nav>
  );
}
